import {create} from 'zustand';
export const useBreadcrumbsStore = create((set) => ({
    breadcrumbs: null,
    pagename: null,
    setBreadcrumbs: (breadcrumbs) => set({ breadcrumbs }),
    setPagename: (pagename) => set({ pagename }),
}));